import { RouteRecordName } from 'vue-router'

/*
  Composable который возвращает boolean переменную, в зависимости от переданных routes
  Передаем массив путей, в которых ожидаем, что элемент будет виден
*/
export const useContentVisibleByRoute = (routes: RouteRecordName[]) => {
  const route = useRoute()
  const trackableRoutes = new Set<RouteRecordName>(routes)

  const currentRoute = ref(route.name)

  watch(
    () => route.name,
    (newRouteName) => (currentRoute.value = newRouteName),
  )

  const isRouteTracked = computed(
    () => currentRoute.value && trackableRoutes.has(currentRoute.value),
  )

  return {
    isVisible: isRouteTracked,
  }
}
